import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './market.css';
import Modal from 'react-modal';
import { isMobile } from 'react-device-detect';
Modal.setAppElement('#root');

const Yama=()=>{
    const [wow, setwow] = useState({});
    const [pwck, setpwck] = useState();
    const [idname, setidname] = useState();
    const [idc, setidc] = useState(false);
    const [pc, setpc] = useState(false);
    const [spin, setspin] = useState(false);
    const [prg, setprg] = useState();
    const [ming, setming] = useState();
    const [kii, setkii] = useState();
    const [onde, setonde] =useState(false);
    const [uka, setuka] = useState();
    const customStyles = {
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
        },
      };

    const jama = async (co)=>{
        co.preventDefault();
        const setn = co.target.id.value;
      
        if(idname !== setn){
            document.getElementById('ida').innerText="중복 확인 필요";
            return;
        };
        if(!idc){
            document.getElementById('ida').innerText="중복 확인 필요";
            return;
        };
        if(!pc){
            document.getElementById('toka').innerText="번호 확인 필요";
            return;
        };
        if(!onde){
            document.querySelector('#jni').innerText = "일치하지 않아요";
            return;
        };
        const aruki = document.querySelector('input[name="mail"]').value;
        
        if(aruki !== uka){
            document.getElementById('sosok').innerText = "메일 변경 확인 필요";
            return;
        }
        
        setspin(true);
        const jana = await axios.post('/api',{id : co.target.id.value, pw : co.target.pw.value, mail : co.target.mail.value, name : co.target.mingzi.value},
        {onUploadProgress : data=>{if(data.total){setprg(Math.round((100*data.loaded)/data.total))}}})
        .then(res=>{setwow(res.data); setspin(false);}).catch(e=>{
            const missy = e.response?.data?.condition;
            if(missy === "rollover"){
                const lawsc = e.response?.data?.missing;
                if(lawsc === "id"){document.getElementById('ida').textContent="ID를 입력해주세요";} else if(lawsc === "name"){
                    document.getElementById('poku').textContent = "이름을 입력해주세요";
                } else if(lawsc === "pw"){ document.getElementById('toku').textContent = "번호를 입력해주세요";} else if(lawsc ==="mail"){
                    document.getElementById('sosok').textContent = "메일을 입력해주세요";
                }
            }else if(missy === "notpassword"){
                document.getElementById('toku').textContent = "비밀번호는 영문, 숫자, 특수문자 조합의 6자리 이상 10자리 이하입니다";
            }else if(missy === "redundancy"){
                document.getElementById('ida').textContent = "이미 사용 중이네요";
            }else if(missy ==="nojoin"){ document.querySelector('#jni').textContent = "일시적 오류가 발생했어요"; } else{
                document.querySelector('#jni').textContent = "일시적 오류가 발생했어요";
            };
            setspin(false);});
    };

    const noth = async ()=>{
        //const kake = await axios.get('api/gone').then(dadi=>dadi.data).catch(e=>console.log("zaza"));
        window.open("http://localhost:3001/api/auth/google", "_self"); 
    };

    const jwjw = async ()=>{
        const kake = await axios.post('api/very').then(dadi=>dadi.data).catch(e=>console.log("JWT-auth"));
    };

    if(wow?.id){
        setTimeout(() => {
         window.location.href = "../join";}, 2000);
    };

    // const re = /^[a-zA-Z0-9\D]{6,10}$/;

    // const re = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\[\]{}|]).{6,10}$/;
    // const re = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{6,10}$/;
    const re = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[#?!@$%^&*\- ]).{6,10}$/;
    const pwcheck=(e)=>{
        const ok = re.test(e.target.value);
     
        if(!ok){
            document.getElementById('toku').innerText="영문, 숫자, 특수문자 포함 6자리 이상 10자리 이하입니다.(#?!@$ %^&*-)";
            setpwck();
        }else{
            setpwck(e.target.value);
            document.getElementById('toku').innerText="ok";
        };
    };
    const namecheck=(e)=>{
        const fok = e.target.value;
        const fkk = ke.test(fok);
   
        if(!fkk){
            document.getElementById('poku').innerText="수상 이력 확인을 위해 필요합니다";
            setming();
        }else{
            setming(e.target.value);
            document.getElementById('poku').innerText="ok";
        };
    };
    const pwchecka=(e)=>{
        const fok = e.target.value;
      
        if(fok == pwck){
            document.getElementById('toka').innerText="ok";
            setpc(true);
        }else if(!fok){
            document.getElementById('toka').innerText="번호를 입력해주세요";
            setpc(false);
        }else{
            document.getElementById('toka').innerText="번호가 일치하지 않아요";
            setpc(false);
        }
    };
    const ke = /^[가-힣a-zA-Z0-9]{2,10}$/;
    const idcheck= async (e)=>{
        const iddd = e.target.value;
        const okk = ke.test(iddd);
        if(!okk){
            document.getElementById('ida').innerText="한글, 영문, 숫자로 2개 이상 10개 이하 문자로 구성!";
            setidc(false);
        }else{
            // const retua = await axios.get(`/api/idcheck/${iddd}`).then(aa=>{return aa.data;}).catch(err=>console.log("err in idcheck"));
            // if(retua){
            //     document.getElementById('ida').innerText="ok";
            //     setidc(true);
            //     setidname(iddd);
            // }else{
            //     document.getElementById('ida').innerText="이미 사용 중이네요";
            //     setidc(false);
            // };
            try {
                const response = await axios.get(`/api/idcheck/${iddd}`);
                const isAvailable = response.data;
              
                if (isAvailable) {
                  document.getElementById('ida').textContent = "ok";
                  setidc(true);
                  setidname(iddd);
                } else {
                  document.getElementById('ida').textContent = "이미 사용 중이네요";
                  setidc(false);
                }
              } catch (err) {
                console.error("err in idcheck", err);
                document.getElementById('ida').textContent = "오류가 발생했습니다";
                setidc(false);
              }
        };
    };

    let submitop = false;
    const authy= async ()=>{
        const dmal = document.querySelector('input[name="mail"]').value;
        // const re = /\S+@\S+\.\S+/;
        const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const hang = re.test(dmal);
        if(submitop){return;};
        if(kii){return;};
        if (!dmal.trim()) {
            alert("이메일을 입력해 주세요");
            return;
        };
        if(!hang){
            alert("이메일 형식이 맞지 않습니다");
            return;
        };
        submitop = true;
        const sbut = document.querySelector('#canbi');
        sbut.classList.add('dith');
        try{
            const dims = await axios.post('/api/gotmail', {mail : dmal});
            setkii(dims.data.condition);
        }catch(err){
            if(err.response.data.condition == "mailaddress"){
                document.getElementById('sosok').textContent = "메일주소 확인이 필요해요";
            };
        }finally{
            submitop = false;
            sbut.classList.remove('dith');
        };
    };

    const matchy= async ()=>{
        const kiib = document.querySelector('input[name="firm"]').value;
        const dmal = document.querySelector('input[name="mail"]').value;
        if(kii !== "prove"){
            document.querySelector('#jni').textContent = "인증 과정이 필요해요"; 
            document.querySelector('#jni').style.fontWeight = "500";
            return;
        };
        try{
            const dims = await axios.post('/api/verifyc', {mail : dmal, code : kiib});
            if(dims.data.condition === "passup"){
                document.querySelector('#jni').textContent = "✅완료!";
                document.querySelector('#jni').style.fontWeight = "500";
                setonde(true);
                // const gabian = document.querySelector('input[name="mail"]').value;
                setuka(dmal);
            }
        }catch(err){
            const beens = document.querySelector('#jni');
            const condition = err.response?.data?.condition;
            if(condition === "overtime"){
                beens.textContent = "인증 시간이 만료되었거나 인증 요청 이력이 없습니다";
            } else if (condition === "notsame"){
                beens.textContent = "일치하지 않아요";
            } else if (condition === "serviceout"){
                beens.textContent = "메일로 문의해주세요";
            } else if (condition === "notverify"){
                beens.textContent = "이메일과 인증번호 모두 입력해주세요"
            } else{
                beens.textContent = "일시적인 오류가 발생했습니다"
            };
            beens.style.fontWeight = "500";
            setonde(false);
        };

        // if(kii == kiib){
          
        //     document.querySelector('#jni').innerText = "✅완료!";
        //     document.querySelector('#jni').style.fontWeight = "500";
        //     setonde(true);
        //     const gabian = document.querySelector('input[name="mail"]').value;
        //     setuka(gabian);
        // }else{
            
        //     document.querySelector('#jni').innerText = "일치하지 않아요";
        //     document.querySelector('#jni').style.fontWeight = "500";
        //     setonde(false);
        // };
    };

    document.title = "일반회원 가입 - 돌파공모";
   
    return(
    <>
    <Modal isOpen={spin} style={customStyles}><progress className="pure-material-progress-circular"/></Modal>
    
    {wow?.id ? <><h2 className={isMobile ? "mongs" : "ongs"}>새로운 도약에 도전을 결정하셨네요!! 반드시 굉스터 단계까지 자기개발에 힘써주세요^^</h2></> :
        <>
        <h2>회원가입{prg}</h2>
        <form className={isMobile ? 'mfamm' : 'famm'} onSubmit={jama}>
        <div className={isMobile ? 'mhoiwon' : 'hoiwon'}>
           
            <h3><label for="id">아이디</label></h3>
            <span className='j1'>
                <input type='text' name='id' required onBlur={idcheck}/>
            </span>
            <span id="ida"></span>
                    
            <h3><label for="mingzi">이름</label></h3>
            <span className='j1'>
                <input type='text' name='mingzi' required onBlur={namecheck}/>
            </span>
            <span id="poku"></span>

            <h3><label for="pw">비밀번호</label></h3>   
            <span className='j1'>
                <input type='password' name='pw' required  onBlur={pwcheck}/>
            </span>
            <span id='toku'></span>
                    
            <h3><label for="pwcc">비밀번호 재확인</label></h3>   
            <span className='j1'>
                <input type='password' name='pwcc' required  onBlur={pwchecka}/>
            </span>
            <span id='toka'></span>
                    
            <h3><label for="mail">이메일</label></h3>  
            <span className='j1'>
                <input type="email" name="mail" pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" title="이메일 형식으로 입력해주세요" required />
            </span>
            <span id='sosok'></span>
            <span className='jiyip' id='canbi' onClick={authy} >
                인증메일 발송{kii && <span style={{marginLeft:"6px"}}>완료</span>}
            </span>
            <h3><label for="mail">번호입력</label></h3>
            <div style={{width:"100%", margin:"0 auto"}}>
            <span className='jeonson'>
                <input type='text' name='firm'  className='jeoninput'/>
            </span>
            <span>
                <span onClick={matchy} className='jiyip2'>확인</span>
                <span id='jni'></span>
            </span>
            </div>
            <button className='gayip' onSubmit={jama}>가입하기</button>
        </div>
        </form>
        </> 
    }
   </>
    );
    }
    
    export default Yama;